import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/utils/api';

export function AdminLoginPage() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = 'Yönetim Girişi | ESDFL';
  }, []);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await api.post('/api/admin/login', { password });
      navigate('/__admin/panel');
    } catch (err: any) {
      setError(err?.message || 'Giriş başarısız');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-gray-50">
      <div className="card w-full max-w-md p-6">
        <h1 className="text-xl font-semibold mb-4">Yönetim Girişi</h1>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="label">Parola</label>
            <input className="input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Parolanızı giriniz" required />
          </div>
          {error && <div className="text-sm text-red-600">{error}</div>}
          <button type="submit" className="btn w-full" disabled={loading}>{loading ? 'Giriş yapılıyor…' : 'Giriş Yap'}</button>
        </form>
      </div>
    </div>
  );
}


